/**
 * 选购交互轻量 API：取消「浏览沉默问询」倒计时
 *
 * 供 SelectProduct / ProductItem / cartAddAndDetail 等直接引用。
 * 勿从 antiHarassment 或 tips 间接引入，避免拖入助手主模块。
 */

let silenceTimer = null;
let silenceCancelled = false;

export function isSilenceCancelled() {
  return silenceCancelled;
}

export function markSilenceCancelled() {
  silenceCancelled = true;
}

export function clearSilenceTimer() {
  if (silenceTimer) {
    clearTimeout(silenceTimer);
    silenceTimer = null;
  }
}

export function resetSilenceScheduling() {
  clearSilenceTimer();
  silenceCancelled = false;
}

export function scheduleSilenceTimer(fn, delay) {
  clearSilenceTimer();
  silenceTimer = setTimeout(fn, delay);
}

/** 选购交互后取消本轮沉默问询 */
export function notifyShoppingInteract() {
  markSilenceCancelled();
  clearSilenceTimer();
}
